import { useEffect, useState } from 'react';

// TODO: to refactor and optimize
export const useDataPerPage = () => {
  const [dataPerPage, setDataPerPage] = useState(8);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setDataPerPage(3);
      } else if (window.innerWidth <= 1799) {
        setDataPerPage(6);
      } else {
        setDataPerPage(8);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return dataPerPage;
};

export const getAccordionData = (data: Record<string, string> | undefined) => {
  if (!data) {
    return [];
  }

  return Object.keys(data)
    .filter((key) => key.startsWith('background_title_'))
    .map((key, index) => {
      const textKey = `background_text_${index + 1}`;
      return {
        title: data[key],
        text: data[textKey],
      };
    })
    .filter((item) => item.title && item.text);
};

// Founder 2026-10-03: the "Project:" heading may be reworded per project from the
// served labels (key_impact_data_live.labels_json), key `project.heading.<title>`
// with the card's title VERBATIM (case, commas and spaces kept). No label, or a
// blank one (useLabels treats blank as absent), shows the title as before. Only
// the heading text changes: group.group itself - which the card row, the map and
// the deforestation-card checks read - is never touched.
export const projectHeadingText = (
  t: (key: string, fallback: string) => string,
  title: string | null | undefined,
): string => {
  if (!title) return title ?? '';
  return t(`project.heading.${title}`, title);
};
